export default angular
    .module('syTtoc', [])
    /**
     * @ngdoc service
     * @name syTtoc.service:T2CService
     * @description
     * Creates a service that handles cookies and $http request.
     */
    // @ngInject
    .service('T2CService', [
        '$cookies',
        '$q',
        '$http',
        '$document',
        function ($cookies, $q, $http, $document) {
            var cookieNamespace = 'synergy.t2c.promoCode'
            var signUpResponse = {}
            // Gets the T2C promo code stored in the cookies.
            this.getPromoCodeFromCookie = function () {
                var raw = $cookies.get(cookieNamespace)
                if (!raw) {
                    return null
                }

                var array = raw.split('|')
                if (array.length !== 2) {
                    return null
                }

                var data = array[0]
                var date = new Date(array[1])
                var currentDate = new Date()

                return date < currentDate ? null : data
            }

            // Sets the T2C promo code stored in the cookies with a 60 minutes expiry.
            this.setPromoCodeInCookie = function (code) {
                // Build the cookie value
                var date = new Date(new Date().getTime() + 900000 * 4)
                var data = code + '|' + date
                // TODO: Put default path in config
                $cookies.put(cookieNamespace, data, { path: '/Sites' })
            }

            // Clear the T2C promo code stored in the cookies
            this.clearPromoCodeInCookie = function () {
                $cookies.remove(cookieNamespace)
            }

            // Gets the T2C data from Sitecore API
            this.getData = function (method, url, data) {
                var deferred = $q.defer()
                $http({ method: method, url: url, data: data }).then(
                    function (response) {
                        deferred.resolve(response.data)
                    },
                    function (response) {
                        if (response.status === 404) {
                            deferred.reject()
                        } else {
                            deferred.resolve(null)
                        }
                    }
                )
                return deferred.promise
            }

            // Gets the colour hex from the stylesheets.
            // TODO: Need to implement recursive function if CSS is to move into @imports
            this.getColour = function (colourName) {
                var className = '.block--' + colourName
                var result = '#000000'
                var rules = ''
                for (var i = 0; i < $document[0].styleSheets.length; i++) {
                    var sheet = $document[0].styleSheets[i]
                    // Need to also filter out the vendor scripts. Previously the code was not filtering out these scripts.
                    if (sheet != '' && sheet.href && !sheet.href.includes('stellar')) {
                        rules = sheet.rules ? sheet.rules : sheet.cssRules
                        for (var j = 0; j < rules.length; j++) {
                            var rule = rules[j]
                            if (rule.style && rule.selectorText && rule.selectorText.indexOf(className) >= 0) {
                                result = rule.style.backgroundColor
                            }
                        }
                    }
                }
                return result
            }

            // Submits the reminder request.
            this.submitReminder = function (method, url, data) {
                var deferred = $q.defer()
                $http({ method: method, url: url, data: data }).then(
                    function () {
                        deferred.resolve()
                    },
                    function (response) {
                        if (response.status === 404) {
                            deferred.reject('Data file could not be found.')
                        } else if (response.status === 500) {
                            deferred.reject('There was an error with your submission.')
                        }
                    }
                )
                return deferred.promise
            }

            // Submits the reject request.
            this.submitReject = function (method, url, data) {
                var deferred = $q.defer()
                $http({ method: method, url: url, data: data }).then(
                    function () {
                        deferred.resolve()
                    },
                    function (response) {
                        if (response.status === 404) {
                            deferred.reject('Data file could not be found.')
                        } else if (response.status === 500) {
                            deferred.reject('There was an error with your submission.')
                        }
                    }
                )
                return deferred.promise
            }

            // Submits the form.
            this.submitForm = function (method, url, data) {
                return $http({ method: method, url: url, data: data }).then(function (response) {
                    return response
                })
            }

            // Submits the request for callback.
            this.submitRequestForCallback = function (method, url, data) {
                var deferred = $q.defer()
                $http({ method: method, url: url, data: data }).then(
                    function () {
                        deferred.resolve()
                    },
                    function (response) {
                        if (response.status === 404) {
                            deferred.reject('Data file could not be found.')
                        } else if (response.status === 500) {
                            deferred.reject('There was an error with your submission.')
                        }
                    }
                )
                return deferred.promise
            }

            this.saveSignUpData = function (data) {
                signUpResponse = data
            }
            this.getSignUpData = function () {
                return signUpResponse
            }
        }
    ])
    /**
     * @ngdoc controller
     * @name syTtoc.controller:T2CCountDownController
     * @description
     * Scope for the T2C countdown module.
     */
    // @ngInject
    .controller('T2CCountDownController', [
        '$scope',
        '$timeout',
        'T2CService',
        function ($scope, $timeout, T2CService) {
            var controller = this
            this.method = 'POST'
            this.apiUrl = 'https://quality2.synergy.net.au/T2CApi/PostT2CData'
            this.data = null

            var getData = function (promoCode) {
                var data = { promoCode: promoCode }
                T2CService.getData(controller.method, controller.apiUrl, data).then(
                    function (value) {
                        controller.data = value
                    },
                    function () {
                        controller.data = null
                    }
                )
            }

            // Checks if the user is logged in (i.e. data is in cookies).
            this.isLoggedIn = function () {
                return controller.data ? true : false
            }

            // Retrieves the offer ends time remaining based on the provided date/time component.
            this.offerEnds = function (component) {
                if (!controller.data) {
                    return null
                }

                var currentTime = new Date().getTime()
                var expiryTime = new Date(controller.data.ExpiryDate).getTime()
                var diff = expiryTime - currentTime

                if (diff <= 0) {
                    return 0
                }

                var days = diff / 86400000
                if (component === 'days') {
                    return Math.floor(days)
                }

                var hours = (days - Math.floor(days)) * 24
                if (component === 'hrs') {
                    return Math.floor(hours)
                }

                var mins = (hours - Math.floor(hours)) * 60
                if (component === 'mins') {
                    return Math.floor(mins)
                }

                var secs = (mins - Math.floor(mins)) * 60
                if (component === 'secs') {
                    return Math.floor(secs)
                }

                return null
            }

            // Set up watches
            $scope.$watch(
                function () {
                    return T2CService.getPromoCodeFromCookie()
                },
                function (newValue, oldValue) {
                    controller.data = null
                    if (newValue) {
                        getData(newValue)
                    } else if (oldValue) {
                        var extendCookie = confirm(
                            'Your session has expired. Do you wish to continue with this session?'
                        )
                        if (extendCookie) {
                            T2CService.setPromoCodeInCookie(oldValue)
                            getData(oldValue)
                        }
                    }
                }
            )

            // Set up a ticker to trigger countdown
            $scope.timeoutFunction = function () {
                $scope.ticker = $timeout($scope.timeoutFunction, 1000)
            }
            $scope.ticker = $timeout($scope.timeoutFunction, 1000)
        }
    ])
    /**
     * @ngdoc controller
     * @name syTtoc.controller:T2CRequestCallbackController
     * @description
     * Scope for the T2C request for callback module.
     */
    // @ngInject
    .controller('T2CRequestCallbackController', [
        '$scope',
        '$window',
        'T2CService',
        'ModalService2',
        function ($scope, $window, T2CService, ModalService2) {
            var setReminderTemplateId = 't2c-set-reminder'
            var rejectOfferTemplateId = 't2c-reject-offer'

            var controller = this
            this.method = 'POST'
            this.apiUrl = 'https://quality2.synergy.net.au/T2CApi/PostT2CData'
            this.submitReminderUrl = 'https://quality2.synergy.net.au/T2CApi/PostSubmitReminder'
            this.submitRejectUrl = 'https://quality2.synergy.net.au/T2CApi/PostSubmitRejectOffer'
            this.submitRequestForCallbackUrl = 'https://quality2.synergy.net.au/T2CApi/PostSubmitRequestForCallback'
            this.goalId = null
            this.data = null
            this.showRequestForm = false
            this.submittedRequest = false
            this.request = {
                campaignFlag: null,
                leadID: null,
                opportunityID: null,
                firstName: null,
                lastName: null,
                businessName: null,
                connectionAddress: null,
                email: null,
                preferredContact: null,
                mobilePrefix: '+61',
                mobile: null,
                phonePrefix: '+61',
                phone: null,
                preferredTimeframe: null,
                interestedBundling: null,
                comments: null,
                salesEmailAddress: null
            }

            var getData = function (promoCode) {
                var data = { promoCode: promoCode }
                T2CService.getData(controller.method, controller.apiUrl, data).then(
                    function (value) {
                        controller.data = value
                        // Set default request values
                        controller.request.businessName = value.BusinessName
                    },
                    function () {
                        controller.data = null
                    }
                )
            }

            // Checks if the user is logged in (i.e. data is in cookies).
            this.isLoggedIn = function () {
                return controller.data ? true : false
            }

            // Opens the set reminder modal.
            this.setReminder = function () {
                var options = {
                    fields: [
                        {
                            name: 'email',
                            title: 'Email address',
                            type: 'email',
                            validation: {
                                required: true
                            },
                            messages: [
                                {
                                    key: 'required',
                                    message: 'Please enter your email address.'
                                },
                                {
                                    key: 'email',
                                    message: 'Please enter a valid email address.'
                                }
                            ]
                        }
                    ]
                }
                ModalService2.openForm(setReminderTemplateId, options).then(function (value) {
                    var data = {
                        promoCode: T2CService.getPromoCodeFromCookie(),
                        emailAddress: value ? value.email : ''
                    }
                    T2CService.submitReminder(controller.method, controller.submitReminderUrl, data).then(
                        function () {
                            return false
                        },
                        function (value) {
                            ModalService2.openErrorAlert(value, 'Set reminder error')
                        }
                    )
                })
            }

            // Opens the reject offer modal.
            this.rejectOffer = function () {
                var options = {
                    buttonText: {
                        cancel: 'Close & resume',
                        submit: 'Submit'
                    },
                    replaceValues: [
                        {
                            src: '@CurrentTarriff',
                            dest: controller.data.CurrentProduct
                        }
                    ],
                    fields: [
                        {
                            name: 'reason',
                            title: '',
                            type: 'radio',
                            values: 'I don’t really see the benefit|Not a good time for my business|Prefer to do it direct with a person|Other'
                        },
                        {
                            name: 'other',
                            title: 'Other reasons',
                            type: 'text'
                        }
                    ]
                }
                ModalService2.openForm(rejectOfferTemplateId, options).then(function (value) {
                    var data = {
                        promoCode: T2CService.getPromoCodeFromCookie(),
                        leadId: controller.data.LeadId,
                        reason: value ? value.reason : '',
                        otherReasons: value ? value.other : '',
                        goalId: ModalService2.modalTemplates['t2c-reject-offer'].goalId
                    }
                    T2CService.submitReject(controller.method, controller.submitRejectUrl, data).then(
                        function () {
                            $window.location.href = $window.location.protocol + '//' + $window.location.host
                        },
                        function (value) {
                            ModalService2.openErrorAlert(value, 'Reject offer error')
                        }
                    )
                })
            }

            this.doNothing = function () {
                return false
            }

            // Toggle the request a callback form.
            this.toggleRequestForm = function () {
                controller.showRequestForm = !controller.showRequestForm
            }

            // Submit a request to callback.
            this.submit = function () {
                var campaignFlag = controller.request.campaignFlag
                var leadId = controller.request.leadID
                var opportunityId = controller.request.opportunityID
                var salesEmail = controller.request.salesEmailAddress
                if (controller.data != null) {
                    campaignFlag = controller.data.CampaignFlag
                    leadId = controller.data.LeadId
                    opportunityId = controller.data.OpportunityID
                    salesEmail = controller.data.SalesEmail
                }

                var data = {
                    CampaignFlag: campaignFlag,
                    LeadID: leadId,
                    OpportunityID: opportunityId,
                    FirstName: controller.request.firstName,
                    LastName: controller.request.lastName,
                    BusinessName: controller.request.businessName,
                    ConnectionAddress: controller.request.connectionAddress,
                    EmailAddress: controller.request.email,
                    PreferredContact: controller.request.preferredContact,
                    MobileNumber:
                        controller.request.preferredContact === 'Mobile'
                            ? controller.request.mobilePrefix + controller.request.mobile
                            : null,
                    PhoneNumber:
                        controller.request.preferredContact === 'Phone'
                            ? controller.request.phonePrefix + controller.request.phone
                            : null,
                    PreferredTimeFrame: controller.request.preferredTimeframe,
                    InterestedBundling: controller.request.interestedBundling,
                    Comments: controller.request.comments,
                    SalesEmailAddress: salesEmail,
                    GoalId: controller.goalId
                }
                T2CService.submitRequestForCallback(
                    controller.method,
                    controller.submitRequestForCallbackUrl,
                    data
                ).then(
                    function () {
                        controller.submittedRequest = true
                    },
                    function (value) {
                        ModalService2.openErrorAlert(value, 'Submit request for callback error')
                    }
                )
            }

            // Checks if the preferred contact is email, mobile or phone
            this.checkPreferred = function (method) {
                return controller.request.preferredContact === method
            }

            // Set up watches
            $scope.$watch(
                function () {
                    return T2CService.getPromoCodeFromCookie()
                },
                function (newValue) {
                    controller.data = null
                    if (newValue) {
                        getData(newValue)
                    }
                }
            )
        }
    ])
    /**
     * @ngdoc controller
     * @name syTtoc.controller:T2CLandingFormController
     * @description
     * Scope for the T2C landing form module.
     */
    // @ngInject
    .controller('T2CLandingFormController', [
        '$scope',
        '$window',
        'T2CService',
        'ModalService2',
        '$timeout',
        function ($scope, $window, T2CService, ModalService2, $timeout) {
            var setReminderTemplateId = 't2c-set-reminder'
            var expiredDataTemplateId = 't2c-expired-data'
            // Search() , $location
            var controller = this
            this.method = 'POST'
            this.apiUrl = 'https://quality2.synergy.net.au/T2CApi/PostT2CData'
            this.submitReminderUrl = 'https://quality2.synergy.net.au/T2CApi/PostSubmitReminder'
            this.redirectUrl = null
            this.showSubmissionError = false
            $scope.promoCode = null
            $scope.accountNumber = null
            this.successful = false
            // Submit the landing form data and 'log into' the webpage.
            this.submit = function () {
                controller.showSubmissionError = false

                var data = {
                    promoCode: $scope.promoCode,
                    accountNumber: $scope.accountNumber
                }

                T2CService.getData(controller.method, controller.apiUrl, data).then(
                    function (value) {
                        // Check if the data has not expired
                        if (new Date(value.ExpiryDate) >= new Date()) {
                            T2CService.setPromoCodeInCookie(value.PromoCode)
                            if (controller.redirectUrl) {
                                controller.successful = true
                                $timeout(function () {
                                    $window.location.href = controller.redirectUrl
                                }, 20)
                            }
                        } else {
                            var options = {
                                replaceValues: [
                                    {
                                        src: '@SalesFirstName',
                                        dest: value.SalesFirstName
                                    },
                                    {
                                        src: '@SalesFullName',
                                        dest: value.SalesFullName
                                    },
                                    {
                                        src: '@StaffNumber',
                                        dest: value.SalesNumber
                                    }
                                ]
                            }
                            ModalService2.openAlert(expiredDataTemplateId, options)
                        }
                    },
                    function (error) {
                        controller.showSubmissionError = true
                        controller.errorText = error
                    }
                )
            }

            // Opens the set reminder modal.
            this.setReminder = function () {
                var options = {
                    fields: [
                        {
                            name: 'email',
                            title: 'Email address',
                            type: 'email',
                            validation: {
                                required: true
                            },
                            messages: [
                                {
                                    key: 'required',
                                    message: 'Please enter your email address.'
                                },
                                {
                                    key: 'email',
                                    message: 'Please enter a valid email address.'
                                }
                            ]
                        }
                    ]
                }
                ModalService2.openForm(setReminderTemplateId, options).then(function (value) {
                    var data = {
                        promoCode: T2CService.getPromoCodeFromCookie(),
                        emailAddress: value ? value.email : ''
                    }
                    T2CService.submitReminder(controller.method, controller.submitReminderUrl, data).then(
                        function () {
                            return false
                        },
                        function (value) {
                            ModalService2.openErrorAlert(value, 'Set reminder error')
                        }
                    )
                })
            }

            // Checks if promo code is in the cookie
            this.hasPromoCode = function () {
                return T2CService.getPromoCodeFromCookie() ? true : false
            }

            $scope.$watch(
                function () {
                    return $window.location.search.replace('?', '')
                },
                function (newValue) {
                    if (!newValue || !controller.redirectUrl) {
                        return
                    }

                    // Check if there is a query string - Start
                    var queryParam = newValue.split('&')
                    var pCode = null,
                        accNum = null,
                        inputArr = null
                    for (var i = 0; i < queryParam.length; i++) {
                        if (queryParam[i].toLowerCase().indexOf('promocode') >= 0) {
                            inputArr = queryParam[i].split('=')
                            if (inputArr.length > 1) {
                                pCode = inputArr[1]
                            }
                        } else if (queryParam[i].toLowerCase().indexOf('accountnumber') >= 0) {
                            inputArr = queryParam[i].split('=')
                            if (inputArr.length > 1) {
                                accNum = inputArr[1]
                            }
                        } else {
                            //Show some error
                        }
                    }
                    // Check if there is a query string - End
                    if (pCode != null || accNum != null) {
                        // Create the data to be passed
                        var requestData = {
                            promoCode: pCode,
                            accountNumber: accNum
                        }
                        // Verify promocode/ account number and if it is valid (not expired)
                        T2CService.getData(controller.method, controller.apiUrl, requestData).then(
                            function (value) {
                                // Check if the data has not expired
                                if (new Date(value.ExpiryDate) >= new Date()) {
                                    T2CService.setPromoCodeInCookie(value.PromoCode)
                                    if (controller.redirectUrl) {
                                        $window.location.href = controller.redirectUrl
                                    }
                                } else {
                                    var options = {
                                        replaceValues: [
                                            {
                                                src: '@SalesFirstName',
                                                dest: value.SalesFirstName
                                            },
                                            {
                                                src: '@SalesFullName',
                                                dest: value.SalesFullName
                                            },
                                            {
                                                src: '@StaffNumber',
                                                dest: value.SalesNumber
                                            }
                                        ]
                                    }
                                    ModalService2.openAlert(expiredDataTemplateId, options)
                                }
                            },
                            function () {
                                controller.showSubmissionError = true
                                alert('Access code or Account number is not valid')
                            }
                        )
                        //End
                    }
                }
            )
        }
    ])
    /**
     * @ngdoc controller
     * @name syTtoc.controller:T2CSignUpFormController
     * @description
     * Scope for the T2C sign up form module.
     */
    // @ngInject
    .controller('T2CSignUpFormController', [
        '$scope',
        '$window',
        '$timeout',
        'T2CService',
        'syFormHistoryService',
        'ChartService',
        'ModalService2',
        '$cookies',
        function ($scope, $window, $timeout, T2CService, syFormHistoryService, ChartService, ModalService2, $cookies) {
            var controller = this
            this.method = 'POST'
            this.apiUrl = 'https://quality2.synergy.net.au/T2CApi/PostT2CData'
            this.homeUrl = 'http://quality2.synergy.net.au/sites/tariff-and-contracts/'
            this.submitFormUrl = 'https://quality2.synergy.net.au/T2CApi/PostSubmitSignUpForm'
            this.step = 0
            this.displayedProduct = null
            this.data = null
            this.submission = null
            this.chart = null
            this.goalId = null

            var createChartData = function (data) {
                var header = ['Current']
                var series = [{ name: 'Potential bill', data: [{ y: data.CurrentPotentialBill, color: '#474c56' }] }]

                for (var i = 0; i < data.Products.length; i++) {
                    var product = data.Products[i]
                    header.push(product.ProductName)
                    series[0].data.push({
                        y: product.PotentialBill,
                        color: T2CService.getColour(product.ProductClass)
                    })
                }

                return {
                    header: header,
                    series: series
                }
            }

            var getProductActionElement = function (element) {
                return element.parents('.product').find('.product-action')
            }

            var scrollToTop = function () {
                $window.scrollTo(0, 0)
            }

            var scrollToElement = function (element) {
                var body = angular.element('html, body')
                body.animate(
                    {
                        scrollTop: element.offset().top,
                        scrollLeft: 0
                    },
                    300
                )
            }

            var cleanABN = function (abn) {
                return abn && abn.match(/(^[0-9]{9}$|^[0-9]{11}$)/) ? abn : null
            }

            // Checks if the user is logged in (i.e. data is in cookies).
            this.isLoggedIn = function () {
                return controller.data ? true : false
            }

            // Builds the product css classes.
            this.getProductClasses = function (product) {
                var result = 'block--' + product.ProductClass
                return result
            }

            // Displays the specified product information tab.
            this.displayInfo = function (evt, productName) {
                for (var i = 0; i < controller.data.Products.length; i++) {
                    if (controller.data.Products[i].ProductName === productName) {
                        controller.displayedProduct = controller.data.Products[i]
                        if (evt.target) {
                            $timeout(
                                function (param) {
                                    scrollToElement(param.element)
                                },
                                0,
                                true,
                                { element: getProductActionElement(angular.element(evt.target)) }
                            )
                        }
                        return
                    }
                }
            }

            // Hide the specified product information tab.
            this.hideInfo = function () {
                controller.displayedProduct = null
            }

            this.getPotentialSavingLabel = function (value, label) {
                if (label.indexOf('{') >= 0 && label.indexOf('}') >= 0) {
                    var arr = label.split('{')
                    var lbl1 = arr[0]
                    if (arr[1]) {
                        var arr2 = arr[1].split('}')
                        var lbl2 = arr2[0]
                        var lbl3 = arr2[1]
                        lbl2 = lbl2.replace(new RegExp('@Savings1Years', 'g'), value)
                        var result = eval(lbl2).toFixed(0)
                        var finalLabel = lbl1 + '$' + result.toString() + lbl3
                        return finalLabel
                    }
                }
                return label
            }

            this.functiontofindIndexByKeyValue = function (arraytosearch, key, valuetosearch) {
                for (var i = 0; i < arraytosearch.length; i++) {
                    if (arraytosearch[i][key] == valuetosearch) {
                        return i + 1
                    }
                }
                return null
            }

            this.fnSignUpOnclick = function (prd) {
                if (prd.indexOf('eConnect') > -1) {
                    window.location.href =
                        'https://selfserve.synergy.net.au/switchnow.html?pid=SER-TOU-LFS01&econnect=true'
                } else {
                    window.location.href = 'https://selfserve.synergy.net.au/switchnow.html?pid=SER-TOU-LFS01'
                }
            }

            this.fnSignUpOnclickSolar = function (prd) {
                if (prd.indexOf('eConnect') > -1) {
                    window.location.href =
                        'https://selfserve.synergy.net.au/switchnow.html?pid=SER-TOU-SLR01&econnect=true'
                } else {
                    window.location.href = 'https://selfserve.synergy.net.au/switchnow.html?pid=SER-TOU-SLR01'
                }
            }

            this.setPostcode = function (postcodeparms) {
                if (postcodeparms) {
                    var postcode = undefined
                    var temp = postcodeparms.match(/(\d{4})/)
                    if (temp && temp.length > 0) {
                        postcode = parseInt(temp[0])
                    }
                    return postcode
                }
                return undefined
            }

            // Selects the product and progress to the sign up sections
            this.selectProduct = function (product, T2CSignupUrl) {
                var localOffset = new Date().getTimezoneOffset() * 60000
                var time = new Date().getTime()
                var date = new Date()
                date.setTime(time - localOffset)

                var localOffset = new Date().getTimezoneOffset() * 60000
                var time = new Date().getTime()
                var date = new Date()
                date.setTime(time - localOffset)
                controller.submission = {
                    customer: {
                        companyName: controller.data.BusinessName,
                        abn: cleanABN(controller.data.ABN),
                        tradingName: undefined,
                        industry: controller.data.Industry,
                        supplyAddresses: controller.data.SupplyAddresses,
                        accountNumbers: controller.data.AccountNumbers,
                        nmi: controller.data.NMIs,
                        contactFirstName: controller.data.ContactFirstName,
                        contactLastName: controller.data.ContactLastName,
                        mailingAddress: controller.data.ContactMailingAddress,
                        contactEmail: controller.data.ContactEmail,
                        mobilePrefix: controller.data.ContactMobileAreaCode
                            ? controller.data.ContactMobileAreaCode
                            : '+61',
                        mobileNumber: controller.data.ContactMobile,
                        phonePrefix: controller.data.ContactPhoneAreaCode ? controller.data.ContactPhoneAreaCode : '08',
                        phoneNumber: controller.data.ContactPhone,
                        changed: [],
                        ProductRates: product.ProductRates,
                        PriceKeys: product.PriceKeys,
                        SupplyCharges: product.SupplyCharges
                    },
                    offer: {
                        productName: product.ProductName,
                        productTerm: product.ProductTerm,
                        priceKey: product.PriceKey,
                        rateOption: product.ProductRateType,
                        rateName1: product.RateName1,
                        rateName2: product.RateName2,
                        rateName3: product.RateName3,
                        rateName4: product.RateName4,
                        rate1: product.Rate1.toFixed(4),
                        rate2: product.Rate2.toFixed(4),
                        rate3: product.Rate3.toFixed(4),
                        rate4: product.Rate4.toFixed(4),
                        ProductDiscount1: product.ProductDiscount1,
                        ProductDiscount2: product.ProductDiscount2,
                        ProductBuyBack: product.ProductBuyBack.toFixed(4),
                        supplyCharge: product.SupplyCharge,
                        startDate: controller.data.OfferStartDate,
                        endDate: controller.data.OfferEndDate,
                        ProductContractEndDate: product.ProductContractEndDate,
                        billingCycle: controller.data.BillingCycle,
                        securityFlag: controller.data.SecurityFlag,
                        percentageSaving: product.PercentageSaving,
                        pricingDMSRef: controller.data.PricingDMSReference,
                        salesFirstName: controller.data.SalesFirstName,
                        salesNumber: controller.data.SalesNumber
                    },
                    authorisation: {
                        date: date
                    },
                    preferredContact: null,
                    misc: {
                        leadId: controller.data.LeadId,
                        campaignFlag: controller.data.CampaignFlag,
                        opportunityID: controller.data.OpportunityID,
                        customerGroupId: controller.data.CustomerGroupId,
                        margin: controller.data.Margin,
                        testimonialImage: product.TestimonialImageUrl,
                        testimonialQuote: product.TestimonialQuote,
                        testimonialName: product.TestimonialName
                    },
                    confirm: {}
                }

                // Set the preferred contact method
                if (controller.submission.customer.mobileNumber) {
                    controller.submission.preferredContact = 'Mobile'
                } else if (controller.submission.customer.phoneNumber) {
                    controller.submission.preferredContact = 'Phone'
                }

                // Set the lock abn field
                if (controller.submission.customer.abn) {
                    controller.submission.customer.lockAbn = true
                }

                localStorage.removeItem('SignUpData')
                localStorage.removeItem('env')
                localStorage.setItem('SignUpData', JSON.stringify(controller.submission))
                localStorage.setItem('env', 'dev')

                var portalId = $cookies.get('PortalId')
                var contact = ''
                if (controller.data.ContactMobile != null && controller.data.ContactMobile != '') {
                    contact = controller.data.ContactMobileAreaCode + controller.data.ContactMobile
                } else if (controller.data.ContactPhone != null && controller.data.ContactPhone != '') {
                    contact = controller.data.ContactPhoneAreaCode + controller.data.ContactPhone
                } else {
                    contact = ''
                }
                if (product.ProductPageSignUpLink != '' && product.ProductPageSignUpLink != null) {
                    T2CSignupUrl = product.ProductPageSignUpLink
                }
                T2CSignupUrl = T2CSignupUrl.replace('@portalid', portalId != null && portalId != '' ? portalId : '')
                T2CSignupUrl = T2CSignupUrl.replace(
                    '@firstname',
                    controller.data.ContactFirstName != null && controller.data.ContactFirstName != ''
                        ? controller.data.ContactFirstName
                        : ''
                )
                T2CSignupUrl = T2CSignupUrl.replace(
                    '@lastname',
                    controller.data.ContactLastName != null && controller.data.ContactLastName != ''
                        ? controller.data.ContactLastName
                        : ''
                )
                T2CSignupUrl = T2CSignupUrl.replace(
                    '@bsname',
                    controller.data.BusinessName != null && controller.data.BusinessName != ''
                        ? controller.data.BusinessName
                        : ''
                )
                T2CSignupUrl = T2CSignupUrl.replace(
                    '@email',
                    controller.data.ContactEmail != null && controller.data.ContactEmail != ''
                        ? controller.data.ContactEmail
                        : ''
                )
                T2CSignupUrl = T2CSignupUrl.replace('@contactnumber', contact)
                T2CSignupUrl = T2CSignupUrl.replace(
                    '@mailingaddress',
                    controller.data.CustomerMailingAddress1 != null && controller.data.CustomerMailingAddress1 != ''
                        ? controller.data.CustomerMailingAddress1
                        : ''
                )
                T2CSignupUrl = T2CSignupUrl.replace(
                    '@suburb',
                    controller.data.CustomerMailingAddressSuburb != null &&
                        controller.data.CustomerMailingAddressSuburb != ''
                        ? controller.data.CustomerMailingAddressSuburb
                        : ''
                )
                T2CSignupUrl = T2CSignupUrl.replace(
                    '@postcode',
                    controller.data.CustomerMailingAddressPostCode != null &&
                        controller.data.CustomerMailingAddressPostCode != ''
                        ? controller.data.CustomerMailingAddressPostCode
                        : ''
                )
                T2CSignupUrl = T2CSignupUrl.replace(
                    '@state',
                    controller.data.CustomerMailingAddressState != null &&
                        controller.data.CustomerMailingAddressState != ''
                        ? controller.data.CustomerMailingAddressState
                        : ''
                )

                window.location.href = T2CSignupUrl
            }
            // Progress through the form
            this.next = function () {
                controller.step++
                syFormHistoryService.addToHistory(controller.step)
                scrollToTop()
            }

            // Go to the previous page.
            this.previous = function () {
                controller.step--
                syFormHistoryService.addToHistory(controller.step)
                scrollToTop()
            }
            this.addStepToHistory = function () {
                syFormHistoryService.setupForm($scope, watchStep, updateStep)
                this.step = 1
                syFormHistoryService.addToHistory(1)
            }

            // Submit the sign up form.
            this.submit = function () {
                // Compile submission object and post it to the API
                controller.loading = true
                var data = {
                    LeadId: controller.submission.misc.leadId,
                    CampaignFlag: controller.submission.misc.campaignFlag,
                    OpportunityID: controller.submission.misc.opportunityID,
                    CustomerGroupId: controller.submission.misc.customerGroupId,
                    Margin: controller.submission.misc.margin,
                    BusinessPartnerName: controller.submission.customer.companyName,
                    PromoCode: controller.data.PromoCode,
                    ABN: controller.submission.customer.abn,
                    Trading: controller.submission.customer.tradingName,
                    Industry: controller.submission.customer.industry,
                    NewContractStartDate: controller.submission.offer.startDate,
                    NewContractEndDate: controller.submission.offer.endDate,
                    ProductContractEndDate: controller.submission.offer.ProductContractEndDate,
                    ContractAccount: controller.submission.customer.accountNumbers.join(),
                    SecurityFlag: controller.submission.offer.securityFlag,
                    LargeUseSmallUse: controller.data.IsSmallUse ? 'Small Use' : 'Large Use',
                    RateType: controller.submission.offer.rateOption,
                    PricingPlan: controller.submission.customer.PriceKeys.join(),
                    ProductName: controller.submission.offer.productName,
                    ProductTerm: controller.submission.offer.productTerm,
                    ProductRate1: controller.submission.offer.rate1, //added
                    ProductRate2: controller.submission.offer.rate2, //added
                    Productsupplycharge: controller.submission.offer.supplyCharge, //added
                    NMI: controller.submission.customer.nmi.join(), //added
                    ContactFirstName: controller.submission.customer.contactFirstName,
                    ContactLastName: controller.submission.customer.contactLastName,
                    ContactMailingAddress: controller.submission.customer.mailingAddress,
                    ContactEmailAddress: controller.submission.customer.contactEmail,
                    PreferredContact: controller.submission.preferredContact,
                    MobileNumber: controller.submission.customer.mobileNumber,
                    PhoneNumber: controller.submission.customer.phoneNumber,
                    ContactPreferredNumber:
                        controller.submission.preferredContact === 'Mobile'
                            ? controller.submission.customer.mobileNumber
                            : controller.submission.customer.phonePrefix + controller.submission.customer.phoneNumber,
                    SalesFullName: controller.data.SalesFullName,
                    SalesEmailAddress: controller.data.SalesEmail,
                    AcceptTCAndCC: controller.submission.confirm.confirm2,
                    AcceptSmallUse: controller.submission.confirm.confirm4,
                    AuthorisedFirstName: controller.submission.authorisation.authorisedFirstName,
                    AuthorisedLastName: controller.submission.authorisation.authorisedLastName,
                    AuthorisedTitle: controller.submission.authorisation.title,
                    AuthorisedDate: controller.submission.authorisation.date,
                    OfferDMSRef: controller.data.PricingDMSReference,
                    AcceptProductTerm: controller.submission.confirm.confirm5,
                    ChangedValues: controller.submission.customer.changed,
                    PriceKey: controller.submission.customer.PriceKeys.join(), //added
                    GoalId: controller.goalId // Added
                }
                T2CService.submitForm(controller.method, controller.submitFormUrl, data).then(
                    function mySucces(response) {
                        console.log(response)
                        controller.SFresponseStatus = true
                        controller.submittedRequest = true
                        controller.loading = false
                        controller.step++
                        controller.SFresponseMessage = syFormHistoryService.referenceId = response.data
                        syFormHistoryService.addToHistory(controller.step)
                        scrollToTop()

                        console.log(controller.SFresponseMessage)
                    },
                    function myError(response) {
                        controller.loading = false
                        console.log(response)
                    },
                    function (value) {
                        controller.loading = false
                    }
                )
            }

            // Checks if the preferred contact is mobile or phone
            this.checkPreferred = function (method) {
                return controller.submission.preferredContact === method
            }

            // Logs the field that has changed
            this.logChange = function (field) {
                for (var i = 0; i < controller.submission.customer.changed.length; i++) {
                    if (controller.submission.customer.changed[i] === field) {
                        return
                    }
                }

                controller.submission.customer.changed.push(field)
            }

            $scope.$watch(
                function () {
                    return T2CService.getPromoCodeFromCookie()
                },
                function (newValue) {
                    controller.data = null
                    if (newValue) {
                        var data = {
                            promoCode: newValue,
                            extendedData: true
                        }
                        T2CService.getData(controller.method, controller.apiUrl, data).then(
                            function (value) {
                                controller.data = value
                                if (localStorage.getItem('SignUpData') != null) {
                                    controller.submission = JSON.parse(localStorage.getItem('SignUpData'))
                                    $scope.env = localStorage.getItem('env')
                                }

                                var _productName = undefined
                                angular.forEach(controller.data.Products, function (analyticsvalue) {
                                    _productName =
                                        _productName == undefined
                                            ? analyticsvalue.ProductName + ','
                                            : _productName + analyticsvalue.ProductName + ','
                                })

                                var data = createChartData(value)
                                controller.chart = ChartService.createColumnChart(
                                    data.header,
                                    data.series,
                                    null,
                                    null,
                                    '${y:.0f}'
                                )
                                $scope.$broadcast('getAccount', value)
                            },
                            function () {
                                alert('Data file could not be found.')
                                $window.location.href = controller.homeUrl
                            }
                        )
                    } else {
                        if (controller.homeUrl) {
                            $window.location.href = controller.homeUrl
                        }
                    }
                }
            )

            var watchStep = function () {
                return controller.step
            }

            var updateStep = function (value) {
                var step = parseInt(value.replace('##step', ''))
                if (!step || step === NaN) {
                    step = 0
                }

                // Check if the step is in history
                if (syFormHistoryService.hasToken(step)) {
                    if (controller.step !== step) {
                        controller.step = step
                    }
                } else {
                    $window.location.href =
                        $window.location.protocol + '//' + $window.location.host + $window.location.pathname
                }

                // Check if step is #6 which is completed
                if (step === 5) {
                    syFormHistoryService.clear()
                }
            }
        }
    ])
    .directive('autoCompleteCompany', function () {
        return {
            restrict: 'A',
            require: '?ngModel',
            link: function (scope, elem, attr, ngModel) {
                elem.autocomplete({
                    source: function (request, response) {
                        $.ajax({
                            url: 'https://abr.business.gov.au/json/MatchingNames.aspx/?jsonpCallbackParam="callback"&guid=e6bc0c58-3e09-4ab3-a963-50843bec68e0',
                            dataType: 'jsonp',
                            data: {
                                name: request.term
                            },
                            success: function (data) {
                                if (data.Names.length != 0) {
                                    scope.confirmDetailsForm.companyName.$setValidity(
                                        'CustomValidationEntiryNameNotExist',
                                        true
                                    )
                                    scope.confirmDetailsForm.businessName.$setValidity(
                                        'CustomValidationEntiryNameNotExist',
                                        true
                                    )
                                    response()
                                    response(
                                        $.map(data.Names, function (item) {
                                            return {
                                                label: item.Abn + '-' + item.Name,
                                                value: item.Name,
                                                type: item.NameType
                                            }
                                        })
                                    )
                                } else {
                                    if (attr.ngModel != 'controller.submission.customer.businessName') {
                                        scope.confirmDetailsForm.companyName.$setValidity(
                                            'CustomValidationEntiryNameNotExist',
                                            false
                                        )
                                        return
                                    }

                                    scope.confirmDetailsForm.businessName.$setValidity(
                                        'CustomValidationEntiryNameNotExist',
                                        false
                                    )
                                }
                            }
                        })
                    },
                    minLength: 3,
                    select: function (event, ui) {
                        scope.confirmDetailsForm.companyName.$setValidity('CustomValidationEntiryNameNotExist', true)
                        scope.confirmDetailsForm.abn.$setValidity('CustomValidationNotValid', true)
                        scope.confirmDetailsForm.companyName.$setValidity('CustomValidationNotValid', true)
                        scope.confirmDetailsForm.businessName.$setValidity('CustomValidationNotValid', true)
                        scope.confirmDetailsForm.businessName.$setValidity('CustomValidationEntiryNameNotExist', true)
                    },
                    open: function () {
                        $(this).removeClass('ui-corner-all').addClass('ui-corner-top')
                    },
                    close: function () {
                        $(this).removeClass('ui-corner-top').addClass('ui-corner-all')
                    },
                    change: function (event, ui) {
                        if (ui.item == null) {
                            if (attr.ngModel != 'controller.submission.customer.businessName') {
                                scope.confirmDetailsForm.companyName.$setValidity('CustomValidationNotValid', false)
                                return
                            }

                            scope.confirmDetailsForm.businessName.$setValidity('CustomValidationNotValid', false)
                            return
                        }
                        if (ui.item && $.trim(ui.item.type) != 'Entity Name') {
                            //console.log(ui.item);
                        } else {
                            scope.confirmDetailsForm.businessName.$setViewValue('')
                            scope.confirmDetailsForm.businessName.$render()
                        }
                    },
                    search: function (e, u) {
                        $(this).addClass('autocomplete-loader')
                    },
                    response: function (e, u) {
                        $(this).removeClass('autocomplete-loader')
                    }
                })
                elem.autocomplete('option', 'select', function (event, ui) {
                    if ($.trim(ui.item.type) !== 'Entity Name') {
                        var abn = $.trim(ui.item.label.split('-')[0])
                        $.ajax({
                            url: 'https://abr.business.gov.au/json/AbnDetails.aspx/?jsonpCallbackParam="callback"&guid=e6bc0c58-3e09-4ab3-a963-50843bec68e0',
                            dataType: 'jsonp',
                            data: {
                                abn: abn
                            },
                            success: function (data) {
                                scope.confirmDetailsForm.companyName.$setValidity(
                                    'CustomValidationEntiryNameNotExist',
                                    true
                                )
                                scope.confirmDetailsForm.abn.$setValidity('CustomValidationNotValid', true)
                                scope.confirmDetailsForm.companyName.$setValidity('CustomValidationNotValid', true)
                                scope.confirmDetailsForm.businessName.$setValidity('CustomValidationNotValid', true)
                                scope.confirmDetailsForm.businessName.$setValidity(
                                    'CustomValidationEntiryNameNotExist',
                                    true
                                )
                                scope.confirmDetailsForm.abn.$setValidity('CustomValidationabn', true)
                                scope.confirmDetailsForm.companyName.$setViewValue(data.EntityName)
                                scope.confirmDetailsForm.companyName.$render()
                                scope.confirmDetailsForm.businessName.$setViewValue(ui.item.label.split('-')[1])
                                scope.confirmDetailsForm.businessName.$render()
                                scope.confirmDetailsForm.abn.$setViewValue(data.Abn)
                                scope.confirmDetailsForm.abn.$render()
                                $('#confirmDetailsForm-businessName').val(ui.item.label.split('-')[1])
                            }
                        })
                    } else {
                        scope.confirmDetailsForm.abn.$setViewValue($.trim(ui.item.label.split('-')[0]))
                        scope.confirmDetailsForm.abn.$render()
                        scope.confirmDetailsForm.companyName.$setViewValue($.trim(ui.item.label.split('-')[1]))
                        scope.confirmDetailsForm.companyName.$render()
                        scope.confirmDetailsForm.businessName.$setViewValue('')
                        scope.confirmDetailsForm.businessName.$render()
                        scope.confirmDetailsForm.companyName.$setValidity('CustomValidationEntiryNameNotExist', true)
                        scope.confirmDetailsForm.abn.$setValidity('CustomValidationNotValid', true)
                        scope.confirmDetailsForm.companyName.$setValidity('CustomValidationNotValid', true)
                        scope.confirmDetailsForm.businessName.$setValidity('CustomValidationNotValid', true)
                        scope.confirmDetailsForm.businessName.$setValidity('CustomValidationEntiryNameNotExist', true)
                        scope.confirmDetailsForm.abn.$setValidity('CustomValidationabn', true)
                    }
                })
            }
        }
    })
    .directive('autoCompleteAbn', function () {
        return {
            restrict: 'A',
            link: function (scope, elem, attr, ctrl) {
                elem.autocomplete({
                    source: function (request, response) {
                        if (request.term.length == 9) {
                            $.ajax({
                                url: 'https://abr.business.gov.au/json/AcnDetails.aspx/?jsonpCallbackParam="callback"&guid=e6bc0c58-3e09-4ab3-a963-50843bec68e0',
                                dataType: 'jsonp',
                                data: {
                                    acn: request.term
                                },
                                success: function (data) {
                                    $('#confirmDetailsForm-abn').show()

                                    var uData = {
                                        resp: data
                                    }
                                    response()
                                    response(
                                        $.map(uData, function (item) {
                                            if (
                                                item.Abn != '' &&
                                                item.Message != 'No record found' &&
                                                item.Message == ''
                                            ) {
                                                scope.confirmDetailsForm.abn.$setValidity('CustomValidationabn', true)
                                                return {
                                                    label: item.Abn + '-' + item.EntityName,
                                                    value: item.Abn
                                                }
                                            }

                                            scope.confirmDetailsForm.abn.$setValidity('CustomValidationabn', false)
                                        })
                                    )
                                },
                                error: function () {
                                    $('#confirmDetailsForm-abn').hide()
                                }
                            })
                        } else {
                            $.ajax({
                                url: 'https://abr.business.gov.au/json/AbnDetails.aspx/?jsonpCallbackParam="callback"&guid=e6bc0c58-3e09-4ab3-a963-50843bec68e0',
                                dataType: 'jsonp',
                                data: {
                                    abn: request.term
                                },
                                success: function (data) {
                                    var uData = {
                                        resp: data
                                    }
                                    response()
                                    response(
                                        $.map(uData, function (item) {
                                            if (
                                                item.Abn != '' &&
                                                item.Message != 'No record found' &&
                                                item.Message == ''
                                            ) {
                                                scope.confirmDetailsForm.abn.$setValidity('CustomValidationabn', true)
                                                return {
                                                    label: item.Abn + '-' + item.EntityName,
                                                    value: item.Abn
                                                }
                                            }

                                            scope.confirmDetailsForm.abn.$setValidity('CustomValidationabn', false)
                                        })
                                    )
                                }
                            })
                        }
                    },
                    minLength: 3,
                    select: function (event, ui) {
                        scope.confirmDetailsForm.companyName.$setValidity('CustomValidationEntiryNameNotExist', true)
                        scope.confirmDetailsForm.abn.$setValidity('CustomValidationNotValid', true)
                        scope.confirmDetailsForm.companyName.$setValidity('CustomValidationNotValid', true)
                        scope.confirmDetailsForm.businessName.$setValidity('CustomValidationNotValid', true)
                        scope.confirmDetailsForm.businessName.$setValidity('CustomValidationEntiryNameNotExist', true)
                        scope.confirmDetailsForm.companyName.$setViewValue(ui.item.label.split('-')[1])
                        scope.confirmDetailsForm.companyName.$render()
                        scope.confirmDetailsForm.businessName.$setViewValue('')
                        scope.confirmDetailsForm.businessName.$render()
                    },
                    open: function () {
                        $(this).removeClass('ui-corner-all').addClass('ui-corner-top')
                    },
                    close: function () {
                        $(this).removeClass('ui-corner-top').addClass('ui-corner-all')
                    },
                    search: function (e, u) {
                        $(this).addClass('autocomplete-loader')
                    },
                    change: function (event, ui) {
                        if (ui.item == null) {
                            scope.confirmDetailsForm.abn.$setValidity('CustomValidationNotValid', false)
                        } else {
                            scope.confirmDetailsForm.abn.$setValidity('CustomValidationNotValid', true)
                        }
                    },
                    response: function (e, u) {
                        $(this).removeClass('autocomplete-loader')
                    }
                })
            }
        }
    })

    /**
     * @ngdoc controller
     * @name syTtoc.controller:T2CSignUpFormController
     * @description
     * Scope for the T2C sign up form module.
     */
    // @ngInject
    .controller('T2CPortalIntroController', [
        '$scope',
        '$window',
        '$timeout',
        'T2CService',
        'syFormHistoryService',
        'ChartService',
        'ModalService2',
        function ($scope, $window, $timeout, T2CService, syFormHistoryService, ChartService, ModalService2) {
            var controller = this
            this.method = 'POST'
            this.apiUrl = 'https://quality2.synergy.net.au/T2CApi/PostT2CData'
            this.homeUrl = 'http://quality2.synergy.net.au/sites/tariff-and-contracts/'
            this.submitFormUrl = 'https://quality2.synergy.net.au/T2CApi/PostSubmitSignUpForm'
            this.data = null
            this.chart = null
            this.step = 1
            this.showCurrentProduct = false
            this.productLabel = ''

            var createChartData = function (data) {
                if (controller.showCurrentProduct) {
                    var header = ['Current']
                    var series = [
                        { name: 'Potential bill', data: [{ y: data.CurrentPotentialBill, color: '#474c56' }] }
                    ]
                } else {
                    var header = []
                    var series = [{ name: 'Potential bill', data: [] }]
                }

                for (var i = 0; i < data.Products.length; i++) {
                    var product = data.Products[i]
                    header.push(product.ProductName)
                    if (controller.productLabel) {
                        series[0].name = controller.productLabel
                    }
                    series[0].data.push({
                        y: product.PotentialBill,
                        color: T2CService.getColour(product.ProductClass)
                    })
                }

                return {
                    header: header,
                    series: series
                }
            }
            var getIEVersion = function () {
                var agent = navigator.userAgent
                var reg = /MSIE\s?(\d+)(?:\.(\d+))?/i
                var matches = agent.match(reg)
                if (matches != null) {
                    return {
                        major: matches[1],
                        minor: matches[2]
                    }
                }
                return {
                    major: '-1',
                    minor: '-1'
                }
            }
            var loadChart = function (chartModel) {
                $('#loadchart').highcharts(chartModel)
                if (getIEVersion().major === '10') {
                    for (var i = 0; i < $element.highcharts().series.length; i++) {
                        $element.highcharts().series[i].hide()
                        $element.highcharts().series[i].show()
                    }
                }
            }

            $scope.$watch(
                function () {
                    return T2CService.getPromoCodeFromCookie()
                },
                function (newValue) {
                    controller.data = null
                    if (newValue) {
                        var data = {
                            promoCode: newValue,
                            extendedData: true
                        }
                        T2CService.getData(controller.method, controller.apiUrl, data).then(
                            function (value) {
                                controller.data = value
                                var _productName = undefined
                                angular.forEach(controller.data.Products, function (analyticsvalue) {
                                    _productName =
                                        _productName == undefined
                                            ? analyticsvalue.ProductName + ','
                                            : _productName + analyticsvalue.ProductName + ','
                                })
                                var data = createChartData(value)
                                controller.chart = ChartService.createColumnChart(
                                    data.header,
                                    data.series,
                                    null,
                                    null,
                                    '${y:.0f}'
                                )
                                loadChart(controller.chart)
                                $scope.$broadcast('getAccount', value)
                            },
                            function () {
                                alert('Data file could not be found.')
                                $window.location.href = controller.homeUrl
                            }
                        )
                    } else {
                        if (controller.homeUrl) {
                            $window.location.href = controller.homeUrl
                        }
                    }
                }
            )
        }
    ])

    /**
     * @ngdoc controller
     * @name syTtoc.controller:T2CPortalIntroControllerPE
     * @description
     * Scope for the T2C sign up form module (page editor mode).
     */
    // @ngInject
    .controller('T2CPortalIntroControllerPE', [
        'ChartService',
        function (ChartService) {
            var controller = this
            var createChartData = function (data) {
                var header = ['Current']
                var series = [
                    {
                        name: 'Potential bill',
                        data: [
                            {
                                y: data.CurrentPotentialBill,
                                color: '#474c56'
                            }
                        ],
                        dataLabels: [
                            {
                                enabled: true,
                                y: -15
                            }
                        ]
                    }
                ]
                for (var i = 0; i < data.Products.length; i++) {
                    var product = data.Products[i]
                    header.push(product.ProductName)
                    series[0].data.push({
                        y: product.PotentialBill,
                        color: T2CService.getColour(product.ProductClass)
                    })
                }

                return {
                    header: header,
                    series: series
                }
            }
            var getIEVersion = function () {
                var agent = navigator.userAgent
                var reg = /MSIE\s?(\d+)(?:\.(\d+))?/i
                var matches = agent.match(reg)
                if (matches != null) {
                    return {
                        major: matches[1],
                        minor: matches[2]
                    }
                }
                return {
                    major: '-1',
                    minor: '-1'
                }
            }
            var loadChart = function (chartModel) {
                $('#loadchart').highcharts(chartModel)
                if (getIEVersion().major === '10') {
                    for (var i = 0; i < $element.highcharts().series.length; i++) {
                        $element.highcharts().series[i].hide()
                        $element.highcharts().series[i].show()
                    }
                }
            }
            this.step = 1
            this.data = {
                ContactFirstName: null,
                ContactLastName: null,
                ContactMailingAddress: '3 PICKARD AVE ROCKINGHAM 6168 WA AU',
                CustomerMailingAddress1: '3 PICKARD AVE',
                CustomerMailingAddressSuburb: 'ROCKINGHAM',
                CustomerMailingAddressState: 'WA',
                CustomerMailingAddressPostCode: '6168',
                ContactEmail: null,
                ContactPhoneAreaCode: '08',
                ContactPhone: '99991111',
                ContactMobileAreaCode: '',
                ContactMobile: null,
                SupplyAddresses: ['@SiteAddress'],
                NMIs: ['80010049163'],
                BillingCycle: 'Monthly',
                Product1Rates: [39.68],
                Product2Rates: [9.26],
                Product1RateNames: ['On Peak - cents per day'],
                Product2RateNames: ['Off Peak'],
                OfferStartDate: '2018-12-20T00:00:00',
                OfferEndDate: '2018-07-30T00:00:00',
                PricingDMSReference: '14489381',
                CurrentPotentialBill: 3487.23,
                CurrentTariffRateName1: 'On Peak - cents per day',
                CurrentTariffRateName2: 'Off Peak',
                CurrentTariffRate1: 39.68,
                CurrentTariffRate2: 9.26,
                CurrentTariffDailySupplyCharge: 3,
                SalesEmail: 'fiona.longden@synergy.net.au',
                CustomerGroupId: '0019000000PqCjgAAF',
                IsSmallUse: true,
                TOUStatement: null,
                SecurityFlag: false,
                Products: [
                    {
                        ProductName: 'Business Flexi',
                        PotentialBill: 3487.23,
                        PriceKey: 'BFT-01-P39-O22-S06',
                        ProductRateType: 'Time of Use',
                        RateName1: 'On Peak - cents per day',
                        RateName2: 'On Peak - cents per day',
                        PercentageSaving: 0,
                        Savings1Years: 0,
                        Savings2Years: 0,
                        Rate1: 39.68,
                        Rate2: 9.26,
                        SupplyCharge: 3,
                        Margin: null,
                        ProductClass: 'blue-aqua',
                        ProductHeadline: 'The flexibility of a customised offer tailored to your business needs',
                        YouGetSummary: '',
                        TestimonialImageUrl: '',
                        TestimonialQuote: '',
                        TestimonialName: '',
                        ProductPageSignUpLink: ''
                    }
                ],
                PriceKeys: ['BFT-01-P39-O22-S06'],
                SupplyCharges: [3],
                PromoCode: 'KS111',
                AccountNumbers: ['@AccountNumber'],
                BusinessName: '@BusinessPartnerName',
                ABN: '095113803',
                Trading: null,
                Industry: 'Wood and Wood Products',
                ExpiryDate: '2018-07-30T00:00:00',
                SalesFirstName: 'Fiona',
                SalesFullName: 'Longden',
                SalesNumber: '0862122231',
                CurrentProduct: '@CurrentProduct',
                IsSubmitted: false,
                LeadId: '',
                CampaignFlag: 'Recontracting',
                OpportunityID: '0069000000thsf5AAA',
                Margin: 'Margin 1'
            }
            this.submission = null
            this.chart = ChartService.createColumnChart(
                ['Current', 'Business Flexi', 'Business Saver'],
                [
                    {
                        name: 'Potential bill',
                        data: [
                            {
                                y: 11506.06,
                                color: '#474c56'
                            },
                            {
                                y: 9986.14,
                                color: '#99dbff'
                            },
                            {
                                y: 10930.75,
                                color: '#c0d9af'
                            }
                        ]
                    }
                ],
                null,
                null,
                '${y:.2f}'
            )
            loadChart(this.chart)
            this.displayedProduct = null

            // Create stub methods to allow display of items in page editor mode
            this.isLoggedIn = function () {
                return true
            }
            this.getProductClasses = function (product) {
                var result = 'block--' + product.ProductClass
                return result
            }
            this.displayInfo = function (evt, productName) {
                for (var i = 0; i < controller.data.Products.length; i++) {
                    if (controller.data.Products[i].ProductName === productName) {
                        controller.displayedProduct = controller.data.Products[i]
                        return
                    }
                }
            }
            this.hideInfo = function () {
                controller.displayedProduct = null
            }
            this.selectProduct = function (product) {
                //controller.step = 2;
                controller.submission = {
                    customer: {
                        companyName: controller.data.BusinessName,
                        abn: controller.data.ABN,
                        tradingName: undefined,
                        industry: controller.data.Industry,
                        supplyAddresses: controller.data.SupplyAddresses,
                        accountNumbers: controller.data.AccountNumbers,
                        nmi: controller.data.NMIs,
                        contactFirstName: controller.data.ContactFirstName,
                        contactLastName: controller.data.ContactLastName,
                        contactEmail: controller.data.ContactEmail,
                        mobilePrefix: controller.data.ContactMobileAreaCode
                            ? controller.data.ContactMobileAreaCode
                            : '+61',
                        mobileNumber: controller.data.ContactMobile,
                        phonePrefix: controller.data.ContactPhoneAreaCode ? controller.data.ContactPhoneAreaCode : '08',
                        phoneNumber: controller.data.ContactPhone,
                        ProductRates: product.ProductRates,

                        PriceKeys: controller.data.PriceKeys,
                        SupplyCharges: controller.data.SupplyCharges
                    },
                    offer: {
                        productName: product.ProductName,
                        priceKey: product.PriceKey,
                        rateOption: product.ProductRateType,
                        rateName1: product.RateName1,
                        rateName2: product.RateName2,
                        rateName3: product.RateName3,
                        rateName4: product.RateName4,
                        rate1: product.Rate1,
                        rate2: product.Rate2,
                        rate3: product.Rate3,
                        rate4: product.Rate4,
                        supplyCharge: product.SupplyCharge,
                        margin: product.Margin,
                        startDate: controller.data.OfferStartDate,
                        endDate: controller.data.OfferEndDate,
                        billingCycle: controller.data.BillingCycle,
                        securityFlag: controller.data.SecurityFlag,
                        percentageSaving: product.PercentageSaving,
                        pricingDMSRef: controller.data.PricingDMSReference,
                        salesFirstName: controller.data.SalesFirstName,
                        salesNumber: controller.data.SalesNumber
                    },
                    authorisation: {
                        date: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())
                    },
                    preferredContact: null,
                    misc: {
                        leadId: controller.data.LeadId,
                        customerGroupId: controller.data.CustomerGroupId,
                        testimonialImage: product.TestimonialImageUrl,
                        testimonialQuote: product.TestimonialQuote,
                        testimonialName: product.TestimonialName
                    },
                    confirm: {}
                }
            }
            this.previous = function () {
                controller.step--
            }
            this.next = function () {
                controller.step++
            }
            this.submit = function () {
                controller.step++
            }
            this.checkPreferred = function (method) {
                return controller.submission.preferredContact === method
            }
        }
    ])

    /**
     * @ngdoc directive
     * @name syTtoc.directive:syTtocSignUpFormPE
     * @description
     * Links the controller to the T2C sign up form module (page editor mode).
     */
    // @ngInject
    .directive('syTtocPortalIntroPe', [
        function () {
            return {
                restrict: 'A',
                scope: true,
                controller: 'T2CPortalIntroControllerPE',
                controllerAs: 'controller'
            }
        }
    ])

    /**
     * @ngdoc controller
     * @name syTtoc.controller:T2CSignUpFormControllerPE
     * @description
     * Scope for the T2C sign up form module (page editor mode).
     */
    // @ngInject
    .controller('T2CSignUpFormControllerPE', [
        'ChartService',
        function (ChartService) {
            var controller = this
            this.step = 1
            this.data = {
                BusinessName: '@BusinessName',
                ExpiryDate: new Date(),
                CurrentProduct: 'Business Plan Fifty (L3)',
                CurrentPotentialBill: 11506.06,
                SupplyAddresses: ['Lot Number 44 1 CAMBRIDGE ST WEST LEEDERVILLE WA 6007'],
                CurrentTariffRateName1: 'On Peak',
                CurrentTariffRateName2: 'Off Peak',
                CurrentTariffRate1: 38.72,
                CurrentTariffRate2: 11.92,
                CurrentTariffDailySupplyCharge: 2.21,
                TOUStatement: 'On Peak: Monday to Friday between 8am - 10 pm including public holidays',
                OfferStartDate: new Date(),
                OfferEndDate: new Date(),
                BillingCycle: 'Monthly',
                ABN: '14083138612',
                NMIs: ['80013596340'],
                ContactFirstName: 'Janko',
                ContactLastName: 'Ajam',
                ContactEmail: 'mary.duffy@synergy.net.au',
                IsSmallUse: true,
                Products: [
                    {
                        ProductClass: 'camouflage',
                        ProductName: 'Business Flexi',
                        ProductHeadline: 'A great rate, tailored to your business needs',
                        PotentialBill: 9986.14,
                        PercentageSaving: 13,
                        YouGetSummary: 'Best rate',
                        ProductRateType: 'TOU',
                        RateName1: 'On Peak',
                        RateName2: 'Off Peak',
                        Rate1: 37.18,
                        Rate2: 8.33,
                        SupplyCharge: 0,
                        Savings2Years: 160000,
                        PriceKey: 'BFT-01-P31-O22-S06'
                    },
                    {
                        ProductClass: 'aqua',
                        ProductName: 'Business Saver',
                        ProductHeadline: '5% discount when combined with our most convenient online services',
                        PotentialBill: 10930.75,
                        PercentageSaving: 5,
                        YouGetSummary: 'Best rate',
                        ProductRateType: 'TOU',
                        RateName1: 'On Peak',
                        RateName2: 'Off Peak',
                        Rate1: 37.18,
                        Rate2: 8.33,
                        SupplyCharge: 0,
                        Savings2Years: 240625.88,
                        PriceKey: 'BFT-01-P31-O26-S06'
                    }
                ]
            }
            this.submission = null
            this.chart = ChartService.createColumnChart(
                ['Current', 'Business Flexi', 'Business Saver'],
                [
                    {
                        name: 'Potential bill',
                        data: [
                            {
                                y: 11506.06,
                                color: '#474c56'
                            },
                            {
                                y: 9986.14,
                                color: '#99dbff'
                            },
                            {
                                y: 10930.75,
                                color: '#c0d9af'
                            }
                        ]
                    }
                ],
                null,
                null,
                '${y:.2f}'
            )
            this.displayedProduct = null

            // Create stub methods to allow display of items in page editor mode
            this.isLoggedIn = function () {
                return true
            }
            this.getProductClasses = function (product) {
                var result = 'block--' + product.ProductClass
                return result
            }
            this.displayInfo = function (evt, productName) {
                for (var i = 0; i < controller.data.Products.length; i++) {
                    if (controller.data.Products[i].ProductName === productName) {
                        controller.displayedProduct = controller.data.Products[i]
                        return
                    }
                }
            }
            this.hideInfo = function () {
                controller.displayedProduct = null
            }
            this.selectProduct = function (product) {
                controller.step = 2
                controller.submission = {
                    customer: {
                        companyName: controller.data.BusinessName,
                        abn: controller.data.ABN,
                        tradingName: undefined,
                        industry: controller.data.Industry,
                        supplyAddresses: controller.data.SupplyAddresses,
                        accountNumbers: controller.data.AccountNumbers,
                        nmi: controller.data.NMIs,
                        contactFirstName: controller.data.ContactFirstName,
                        contactLastName: controller.data.ContactLastName,
                        contactEmail: controller.data.ContactEmail,
                        mobilePrefix: controller.data.ContactMobileAreaCode
                            ? controller.data.ContactMobileAreaCode
                            : '+61',
                        mobileNumber: controller.data.ContactMobile,
                        phonePrefix: controller.data.ContactPhoneAreaCode ? controller.data.ContactPhoneAreaCode : '08',
                        phoneNumber: controller.data.ContactPhone,
                        //Product1RateNames:controller.data.Product1RateNames,
                        //Product2RateNames :controller.data.Product2RateNames,
                        Product1Rates: controller.data.Product1Rates,
                        Product2Rates: controller.data.Product1Rates,
                        PriceKeys: controller.data.PriceKeys,
                        SupplyCharges: controller.data.SupplyCharges
                    },
                    offer: {
                        productName: product.ProductName,
                        priceKey: product.PriceKey,
                        rateOption: product.ProductRateType,
                        rateName1: product.RateName1,
                        rateName2: product.RateName2,
                        rate1: product.Rate1,
                        rate2: product.Rate2,
                        supplyCharge: product.SupplyCharge,
                        margin: product.Margin,
                        startDate: controller.data.OfferStartDate,
                        endDate: controller.data.OfferEndDate,
                        billingCycle: controller.data.BillingCycle,
                        securityFlag: controller.data.SecurityFlag,
                        percentageSaving: product.PercentageSaving,
                        pricingDMSRef: controller.data.PricingDMSReference,
                        salesFirstName: controller.data.SalesFirstName,
                        salesNumber: controller.data.SalesNumber
                    },
                    authorisation: {
                        date: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())
                    },
                    preferredContact: null,
                    misc: {
                        leadId: controller.data.LeadId,
                        customerGroupId: controller.data.CustomerGroupId,
                        testimonialImage: product.TestimonialImageUrl,
                        testimonialQuote: product.TestimonialQuote,
                        testimonialName: product.TestimonialName
                    },
                    confirm: {}
                }
            }
            this.previous = function () {
                controller.step--
            }
            this.next = function () {
                controller.step++
            }
            this.submit = function () {
                controller.step++
            }
            this.checkPreferred = function (method) {
                return controller.submission.preferredContact === method
            }
        }
    ])

    /**
     * @ngdoc directive
     * @name syTtoc.directive:syTtoc
     * @description
     * Links the controller to any T2C module.
     */
    // @ngInject
    .directive('syTtoc', [
        function () {
            return {
                restrict: 'A',
                scope: true,
                controller: 'T2CCountDownController',
                controllerAs: 'controller',
                link: function ($scope, $element, attrs, controller) {
                    if (attrs.syTtocMethod) {
                        controller.method = attrs.syTtocMethod
                    }
                    if (attrs.syTtocRest) {
                        controller.apiUrl = attrs.syTtocRest
                    }
                }
            }
        }
    ])

    /**
     * @ngdoc directive
     * @name syTtoc.directive:syTtoc
     * @description
     * Links the controller to any T2C module.
     */
    // @ngInject
    .directive('syTtocPortalIntro', [
        function () {
            return {
                restrict: 'A',
                scope: true,
                controller: 'T2CPortalIntroController',
                controllerAs: 'controller',
                link: function ($scope, $element, attrs, controller) {
                    if (attrs.syTtocMethod) {
                        controller.method = attrs.syTtocMethod
                    }
                    if (attrs.syTtocRest) {
                        controller.apiUrl = attrs.syTtocRest
                    }
                    if (attrs.syTtocSignUpFormHome) {
                        controller.homeUrl = attrs.syTtocSignUpFormHome
                    }
                    if (attrs.syTtocShowCurrentProduct) {
                        controller.showCurrentProduct = attrs.syTtocShowCurrentProduct == 'True' ? true : false
                    }
                    if (attrs.syTtocProductLabel) {
                        controller.productLabel = attrs.syTtocProductLabel
                    }
                }
            }
        }
    ])
    /**
     * @ngdoc directive
     * @name syTtoc.directive:syTtocRequest
     * @description
     * Links the controller to a T2C request for callback module.
     */
    // @ngInject
    .directive('syTtocRequest', [
        function () {
            return {
                restrict: 'A',
                scope: true,
                controller: 'T2CRequestCallbackController',
                controllerAs: 'controller',
                link: function ($scope, $element, attrs, controller) {
                    if (attrs.syTtocRequestMethod) {
                        controller.method = attrs.syTtocRequestMethod
                    }
                    if (attrs.syTtocRequestRest) {
                        controller.apiUrl = attrs.syTtocRequestRest
                    }
                    if (attrs.syTtocRequestSubmitReminder) {
                        controller.submitReminderUrl = attrs.syTtocRequestSubmitReminder
                    }
                    if (attrs.syTtocRequestSubmitReject) {
                        controller.submitRejectUrl = attrs.syTtocRequestSubmitReject
                    }
                    if (attrs.syTtocRequestSubmitRequestForCallback) {
                        controller.submitRequestForCallbackUrl = attrs.syTtocRequestSubmitRequestForCallback
                    }
                    if (attrs.syTtocRequestSubmitGoalId) {
                        controller.goalId = attrs.syTtocRequestSubmitGoalId
                    }
                }
            }
        }
    ])
    /**
     * @ngdoc directive
     * @name syTtoc.directive:syTtocLandingForm
     * @description
     * Links the controller to the T2C landing form module.
     */
    // @ngInject
    .directive('syTtocLandingForm', [
        function () {
            return {
                restrict: 'A',
                scope: true,
                controller: 'T2CLandingFormController',
                controllerAs: 'controller',
                link: function ($scope, $element, attrs, controller) {
                    if (attrs.method) {
                        controller.method = attrs.method
                    }
                    if (attrs.syTtocLandingFormRest) {
                        controller.apiUrl = attrs.syTtocLandingFormRest
                    }
                    if (attrs.syTtocLandingFormRedirect) {
                        controller.redirectUrl = attrs.syTtocLandingFormRedirect
                    }
                    if (attrs.syTtocLandingFormSubmitReminder) {
                        controller.submitReminderUrl = attrs.syTtocLandingFormSubmitReminder
                    }
                }
            }
        }
    ])
    /**
     * @ngdoc directive
     * @name syTtoc.directive:syTtocSignUpForm
     * @description
     * Links the controller to the T2C sign up form module.
     */
    // @ngInject
    .directive('syTtocSignUpForm', [
        function () {
            return {
                restrict: 'A',
                scope: true,
                controller: 'T2CSignUpFormController',
                controllerAs: 'controller',
                link: function ($scope, $element, attrs, controller) {
                    if (attrs.syTtocSignUpFormMethod) {
                        controller.method = attrs.syTtocSignUpFormMethod
                    }
                    if (attrs.syTtocSignUpFormRest) {
                        controller.apiUrl = attrs.syTtocSignUpFormRest
                    }
                    if (attrs.syTtocSignUpFormHome) {
                        controller.homeUrl = attrs.syTtocSignUpFormHome
                    }
                    if (attrs.syTtocSignUpFormSubmitUrl) {
                        controller.submitFormUrl = attrs.syTtocSignUpFormSubmitUrl
                    }
                    if (!attrs.syRemoveStep) {
                        controller.addStepToHistory()
                    }
                }
            }
        }
    ])
    /**
     * @ngdoc directive
     * @name syTtoc.directive:syTtocSignUpFormPE
     * @description
     * Links the controller to the T2C sign up form module (page editor mode).
     */
    // @ngInject
    .directive('syTtocSignUpFormPe', [
        function () {
            return {
                restrict: 'A',
                scope: true,
                controller: 'T2CSignUpFormControllerPE',
                controllerAs: 'controller'
            }
        }
    ])

    /**
     * @ngdoc directive
     * @name syTtoc.directive:sySchoolRequest
     * @description
     * Links the controller to a School Contact form.
     */
    // @ngInject
    .directive('sySchoolRequest', [
        function () {
            return {
                restrict: 'A',
                scope: true,
                controller: 'SchoolRequestController',
                controllerAs: 'controller',
                link: function ($scope, $element, attrs, controller) {
                    if (attrs.sySchoolRequestMethod) {
                        controller.method = attrs.sySchoolRequestMethod
                    }
                }
            }
        }
    ])

    .controller('SchoolRequestController', [
        '$scope',
        function ($scope) {
            var controller = this
            this.method = 'POST'
            $scope.years = [
                {
                    value: 'Year 6',
                    text: 'Year 6'
                },
                {
                    value: 'Year 8',
                    text: 'Year 8'
                },
                {
                    value: 'Both',
                    text: 'Both'
                }
            ]
            $scope.classSizes = [
                {
                    value: '1 team',
                    text: '1 team'
                },
                {
                    value: '1 class',
                    text: '1 class'
                },
                {
                    value: 'Whole year group',
                    text: 'Whole year group'
                }
            ]
            $scope.previouslyParticipated = [
                {
                    value: 'Yes',
                    text: 'Yes'
                },
                {
                    value: 'No',
                    text: 'No'
                }
            ]
        }
    ])
